// Path: ./src/app/components/AccountCardWrapper/index.tsx
import { Box } from "@mui/material";
import React from "react";
import { TopHead, Title, CardBox } from "./styled";

interface Props {
  children: React.ReactNode;
  title: string;
}
export const AccountCardWrapper = ({ children, title }: Props) => {
  return (
    <CardBox
      sx={{
        maxWidth: {
          xs: "100%",
          sm: "100%",
        },
      }}
      data-testid="accountcardwrapper-test-id"
    >
      <TopHead>
        <Title>{title}</Title>
      </TopHead>
      <Box>{children}</Box>
    </CardBox>
  );
};
